var _g, _g2, _ellipse, _g3, _g4, _g5, _ellipse2, _g6, _g7, _ellipse3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyHandsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 227,
    viewBox: "0 0 366 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3986_26499)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3986_26499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.279 70.8203C292.71 67.8656 295.368 63.934 296.774 59.2816C297.978 55.2983 295.303 51.005 293.362 47.3244C293.086 46.8021 292.859 46.2703 292.676 45.7447C292.069 43.999 291.481 42.2039 290.458 40.6643C289.571 39.3296 288.548 37.6342 288.001 36.1874C286.622 32.5447 285.852 31.3084 286.622 28.263C286.834 27.4214 287.287 26.8294 287.844 26.4143C289.931 24.8593 292.379 27.2012 292.943 29.7417C292.981 29.9145 293.026 30.0832 293.085 30.25C293.439 31.2444 294.875 34.8779 297.001 34.8779C299.584 34.8779 298.793 24.2923 298.202 18.7492C298.013 16.9835 299.358 15.4078 301.134 15.3577C302.786 15.3111 304.16 16.6172 304.198 18.2694L304.522 32.292C304.446 33.6625 306.718 32.0979 307.046 30.765C307.803 27.691 309.23 21.9956 310.571 17.2068C311.073 15.416 312.929 14.3885 314.724 14.8755C316.552 15.3716 317.634 17.2541 317.143 19.0839L313.001 34.5006C312.734 35.3827 314.767 36.9913 315.501 36.0006L322.792 24.5143C323.843 22.8595 326.051 22.3968 327.678 23.4906C329.188 24.506 329.662 26.5121 328.766 28.0959L323.013 38.2746C321.74 40.106 320.744 42.1135 320.057 44.2327C319.962 44.5252 319.871 44.8177 319.774 45.1095C319.389 46.2704 318.308 49.482 317.501 51.501C315.842 55.6481 310.451 59.3272 309.159 63.6026L305.495 75.7221C301.507 88.9142 288.957 97.6291 275.178 96.7738C267.579 96.3021 262.349 88.9451 264.4 81.6132L266.03 75.788C274.422 78.2932 283.103 76.1396 289.279 70.8203Z",
    fill: "url(#paint0_radial_3986_26499)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_3986_26499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.1772 71.2682C71.8329 68.1801 69.2916 64.135 68.0246 59.4066C66.9399 55.3583 69.772 51.113 71.8201 47.4564C72.1052 46.9475 72.344 46.4281 72.5392 45.9135C73.1962 44.1818 73.8378 42.4013 74.9067 40.8887C75.8349 39.575 76.911 37.902 77.5032 36.4636C78.9934 32.8446 79.8011 31.6265 79.1227 28.5364C78.9367 27.6888 78.5063 27.0806 77.967 26.6449C75.9317 25.0008 73.3926 27.2774 72.751 29.8139C72.7077 29.9854 72.6581 30.1526 72.5942 30.3175C72.2116 31.3042 70.6643 34.9155 68.5353 34.8442C65.9452 34.7574 67.0649 24.0974 67.8244 18.5475C68.0649 16.7898 66.7722 15.1748 65.0015 15.0652C63.3443 14.9626 61.9214 16.2308 61.8336 17.8888L61.0863 31.9899C61.1204 33.3653 58.8952 31.7266 58.6085 30.381C57.9437 27.2609 56.6829 21.4613 55.4822 16.587C55.0371 14.7801 53.2136 13.6935 51.403 14.1232C49.5577 14.5611 48.4152 16.4103 48.8492 18.2566L52.5336 33.9278C52.7738 34.8243 50.6902 36.3747 49.9862 35.3532L43.0313 23.5444C42.0332 21.8496 39.8317 21.315 38.1674 22.3633C36.6298 23.3317 36.0935 25.3185 36.9349 26.9292L42.3992 37.3894C43.6186 39.2766 44.5551 41.332 45.1794 43.4895C45.2643 43.783 45.345 44.0767 45.432 44.3696C45.7815 45.5458 46.7677 48.8207 47.5162 50.8827C49.0474 55.101 54.3331 58.9851 55.4945 63.3198L58.8001 75.6564C62.3927 89.0641 74.6904 98.2539 88.5066 97.8555C96.1215 97.6359 101.592 90.446 99.7724 83.0483L98.2962 77.0465C89.8208 79.2857 81.1978 76.8276 75.1772 71.2682Z",
    fill: "url(#paint1_radial_3986_26499)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_3986_26499)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182,
    cy: 77.5,
    rx: 100,
    ry: 77.5,
    fill: "url(#paint2_radial_3986_26499)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182,
    cy: 77.5,
    rx: 100,
    ry: 77.5,
    fill: "url(#paint3_radial_3986_26499)",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "soft-light"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3986_26499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 79C223.042 90.0457 205.135 99 182 99C158.866 99 140.959 90.0457 132 79",
    stroke: "#8374CA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3986_26499)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 202,
    cy: 56,
    rx: 15,
    ry: 20,
    fill: "#ECECEC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3986_26499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.314 50C216.314 50 213.5 36 202 36C190.5 36 187.687 50 187.687 50C195.321 41.4662 208.679 41.4662 216.314 50Z",
    fill: "#9183D2"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 202,
    cy: 60,
    rx: 5,
    ry: 7,
    fill: "#7060B6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3986_26499)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 162,
    cy: 56,
    rx: 15,
    ry: 20,
    fill: "#ECECEC"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_3986_26499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.314 50C176.314 50 173.501 36 162 36C150.5 36 147.687 50 147.687 50C155.321 41.4662 168.68 41.4662 176.314 50Z",
    fill: "#9183D2"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162,
    cy: 60,
    rx: 5,
    ry: 7,
    fill: "#7060B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3986_26499",
    x: 0.538086,
    y: 0,
    width: 364.68,
    height: 227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3986_26499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3986_26499",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3986_26499",
    x: 263.952,
    y: 14.7539,
    width: 66.2662,
    height: 85.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3986_26499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_3986_26499",
    x: 36.5381,
    y: 14.0312,
    width: 64.5857,
    height: 86.8359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3986_26499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3986_26499",
    x: 82.0005,
    y: 0,
    width: 201,
    height: 158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3986_26499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3986_26499",
    x: 129,
    y: 77,
    width: 106,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3986_26499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3986_26499",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3986_26499",
    x: 171,
    y: 31,
    width: 62,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3986_26499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3986_26499",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3986_26499",
    x: 171.687,
    y: 31,
    width: 60.6266,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3986_26499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3986_26499",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3986_26499",
    x: 131,
    y: 31,
    width: 62,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3986_26499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3986_26499",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3986_26499",
    x: 131.687,
    y: 31,
    width: 60.6266,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3986_26499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3986_26499",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3986_26499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(309.903 11.795) rotate(106.819) scale(94.786 46.9597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6470DE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3986_26499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3201 11.1855) rotate(75) scale(95.4662 47)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6470DE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3986_26499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182) rotate(90) scale(155 200)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.251268,
    stopColor: "#C7B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505BBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3986_26499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182 77.5) rotate(90) scale(77.5 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyHandsLogo);
export default __webpack_public_path__ + "static/media/HappyHandsLogo.559039ed77ac6d4f525decb232b19c03.svg";
export { ForwardRef as ReactComponent };